<script>
import { mapGetters, mapActions, mapState } from "vuex";

import NavigationWrapper from "@/components/NavigationWrapper";
import InvitationForm from "@/pages/Team/Invitations/InvitationForm";

export default {
  // Included components
  components: {
    NavigationWrapper,
    InvitationForm,
  },

  computed: {
    // List of pending invitations (neither accepted or rejected)
    pendingInvitations() {
      return Object.values(this.teamInvitations).filter(
        (invitation) => !invitation.accepted && !invitation.rejected
      );
    },

    // Mapped vuex state
    ...mapGetters(["activeTeam"]),
    ...mapState(["teamInvitations"]),
  },

  // When the component is created, get the teams invitations
  async created() {
    this.loadCallback();
  },

  methods: {
    async loadCallback() {
      await Promise.all([this.getTeamInvitations({ status: "pending" })]);
    },

    // Mapped vuex actions
    ...mapActions(["getTeams", "postTeamInvitations", "getTeamInvitations"]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/team">Settings</b-breadcrumb-item>
      <b-breadcrumb-item active>Invitations</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Invitations</h1>

    <b-row>
      <b-col>
        <b-card
          class="Card-table mb-3"
          v-if="Object.values(pendingInvitations).length !== 0"
          key="some"
        >
          <b-card-text>
            <b-table
              responsive
              small
              :fields="[
                {
                  key: 'email',
                  label: 'Email',
                  sortable: true,
                },
                {
                  key: 'created_by',
                  label: 'Created By',
                  formatter(value, key, item) {
                    return `${value.name || '@' + value.handle}`;
                  },
                  sortable: true,
                },
                {
                  key: 'role.name',
                  label: 'Role',
                  sortable: true,
                },
              ]"
              :items="pendingInvitations"
            />
          </b-card-text>
        </b-card>

        <b-card v-else class="text-center py-5 mb-3" key="none">
          <b-card-title>No Pending Invitations Sent</b-card-title>
          <b-card-text>
            Use the form below to invite members to this team
          </b-card-text>
        </b-card>

        <h3 class="mb-3">Invite a Team Member</h3>
        <b-card>
          <b-row>
            <InvitationForm :callback="this.loadCallback" />
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </NavigationWrapper>
</template>
